import { getConfig } from '@monorepo/tools/src/lib/get-config';

const LOCAL_MANAGEMENT_API = 'http://localhost:8081/adxmgmtapi/api';

export function getManagementApiBaseUrl(): string {
	const { rootApi, projectEnv, localManagementApi } = getConfig().env;
	const override = localManagementApi?.trim();
	if (override) {
		return override.replace(/\/$/, '');
	}
	if (projectEnv === 'develop' || projectEnv === 'local') {
		return LOCAL_MANAGEMENT_API;
	}
	return rootApi.replace(/\/$/, '');
}
